// extracted by mini-css-extract-plugin
export default {"inactiveHovers":"SidebarTab_inactiveHovers__FJkVw"};